<script setup lang="ts">
// Top-right "Export CSV" download link shown in a page header row.
defineProps<{
  href: string
}>()
</script>

<template>
  <a
    :href="href"
    class="inline-flex items-center gap-2 rounded-lg border border-slate-600 bg-slate-800 hover:border-slate-500 hover:bg-slate-700 text-slate-300 hover:text-white font-semibold px-4 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500"
  >
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
    <slot />
  </a>
</template>
